<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      :id="modalId"
      tabindex="-2"
      :aria-labelledby="modalId"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog" :class="props.modalSize">
        <div class="modal-content">
          <div class="modal-header" v-if="props.isHeader">
            <h5 class="modal-title" :id="modalId + '_Label'">
              {{ props.modalTitle }}
            </h5>
            <a class="mx-2" type="button" data-bs-dismiss="modal" aria-label="Close">x</a>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer" v-if="props.isFooter">
            <button
              type="button"
              class="btn btn-success"
              :data-bs-target="`#${props.targetModalOpen}`"
              data-bs-toggle="modal"
              data-bs-dismiss="modal"
              @click="leftBtnFun()"
            >
              {{ props.leftBtnLabel }}
            </button>
            <button type="button" class="btn btn-outline-success" data-bs-dismiss="modal">
              {{ props.rightBtnLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const emit = defineEmits(["leftBtnFun"]);
const leftBtnFun = () => {
  emit("leftBtnFun");
};
const props = defineProps({
  modalName: {
    type: String,
    required: true,
  },
  modalTitle: {
    type: String,
    required: false,
  },
  rightBtnLabel: {
    type: String,
    required: false,
  },
  leftBtnLabel: {
    type: String,
    required: false,
  },
  isHeader: {
    type: Boolean,
    default: true,
  },
  isFooter: {
    type: Boolean,
    default: true,
  },
  targetModalOpen: String,
  modalSize: String,
});

const modalId = computed(() => {
  return props.modalName.replace(" ", "_");
});

onMounted(() => {
  store.state.openModal = true;
});
</script>
